<span class="shift-group-placeholder">
  <span class="r1-icon r1-icon-star-fill-solid mr-2 shift-group-star"></span>
  <span>Click enter to create a new shift</span>
</span>
